import React, { useState, useContext, ElementType } from 'react';
import Modal from 'components/Modal';
import { noOp } from 'libs/utils';

export interface IModalContext {
  isOpen: boolean;
  component?: ElementType;
  modalClassname?: string;
  toggleModal: (params: any) => void;
  modalName: string;
  isErrorMessage: boolean;
}

const ModalContext = React.createContext<IModalContext>({
  modalClassname: '',
  toggleModal: noOp,
  isOpen: false,
  modalName: '',
  isErrorMessage: false,
});

const defaultModalState = {
  toggleModal: noOp,
  modalName: '',
  isOpen: false,
  isErrorMessage: false,
};

const ModalProvider: React.FC = ({ children }) => {
  const [modalState, setModalState] = useState<IModalContext>(defaultModalState);
  const ModalChildrenComponent = modalState.component as ElementType;

  return (
    <ModalContext.Provider
      value={{
        ...modalState,
        toggleModal: (params: IModalContext) => setModalState(params),
      }}
    >
      {children}
      <Modal {...modalState}>
        {ModalChildrenComponent && <ModalChildrenComponent />}
      </Modal>
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const { toggleModal: setModal, ...state } = useContext(ModalContext);
  return { setModal, state };
};

export default ModalProvider;
